export const ButtonChartTooltipsTypes = {
  Single: "single",
  Multiple: "multiple"
};



// WEBPACK FOOTER //
// ./src/views/components/button_chart_tooltips/ButtonChartTooltipsTypes.js